
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","height":"1em","viewBox":"-2 -1 24 24","width":"1em","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M10.129.261a.75.75 0 00-.258 0l-9 1.565a.75.75 0 000 1.478l1.336.232v2.08L1.05 11.018a.75.75 0 00.733.907h2.348a.75.75 0 00.506-.196 5.837 5.837 0 001.96 2.47.158.158 0 01-.014.005l-.014.006a8.727 8.727 0 00-2.801 1.89 8.804 8.804 0 00-1.889 2.8 8.712 8.712 0 00-.691 3.237.187.187 0 00.187.192h1.406a.187.187 0 00.188-.183 6.988 6.988 0 012.058-4.788A6.985 6.985 0 0110 15.297c1.88 0 3.645.731 4.974 2.06a6.988 6.988 0 012.057 4.788.186.186 0 00.188.183h1.406a.188.188 0 00.188-.192 8.736 8.736 0 00-.692-3.24 8.767 8.767 0 00-1.889-2.8 8.804 8.804 0 00-2.8-1.889c-.01-.005-.02-.007-.029-.012a5.8 5.8 0 002.41-4.71A5.81 5.81 0 0012.822 4.4l6.307-1.097a.75.75 0 000-1.478zm-2.95 4.14l-3.472-.604v1.819l.589 2.747A5.819 5.819 0 017.179 4.4zM10 3.369l-4.623-.804L10 1.761l4.623.804zm-6.797 7.055l-.246-1.149-.246 1.15zm3.947 1.91A4.005 4.005 0 0010 13.516c1.076 0 2.088-.42 2.85-1.182a4.005 4.005 0 001.181-2.85c0-1.075-.42-2.088-1.18-2.85A4.005 4.005 0 0010 5.454c-1.077 0-2.09.419-2.85 1.18a4.005 4.005 0 00-1.182 2.85c0 1.076.42 2.089 1.181 2.85z","fill-rule":"evenodd"}})])
          )
        }
      }
    